// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PWrFW","select":"styles_select__37VqX"};